import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { CustomProvider } from 'rsuite';
import enGB from 'rsuite/locales/en_GB';
import locales from './locales';
import Product from './clientWeb/Products';
import Error404Page from './pages/authentication/404';
import Sign from './clientWeb/Sign';
import BuyerWeb from './clientWeb/BuyerWeb';
// import { appNavs } from './config';





const App = () => {

  return (
    <IntlProvider locale="en" messages={locales.en}>
      <CustomProvider locale={enGB}>
        <Routes>
              <Route index element={<Sign />} />
                 
              <Route path="product" element={<Product />} /> 
              <Route path="buyers" element={<BuyerWeb />} />    
          
            <Route path="*" element={<Error404Page />} />
        </Routes>
        </CustomProvider>
    </IntlProvider>
  );
};

export default App;
